var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: "Remove document" },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _vm.processing
              ? _c("ManagementRemoveDocumentPlaceholder")
              : _c("div", { staticClass: "flex flex-wrap mb-5" }, [
                  !_vm.isAttachedToEntities
                    ? _c("p", [
                        _vm._v(" The document "),
                        _c("span", { staticClass: "font-bold" }, [
                          _vm._v(_vm._s(_vm.fileName)),
                        ]),
                        _vm._v(" will be removed "),
                      ])
                    : _vm.singleEntity
                    ? _c(
                        "p",
                        [
                          _c("span", { staticClass: "mr-1" }, [
                            _vm._v("The document "),
                            _c("span", { staticClass: "font-bold" }, [
                              _vm._v(_vm._s(_vm.fileName)),
                            ]),
                            _vm._v(" is attached to"),
                          ]),
                          _c("UILink", {
                            staticClass: "mr-1 whitespace-no-wrap",
                            attrs: {
                              content: _vm.singleEntity.value,
                              routeParams: _vm.singleEntity.routeParams,
                              textBase: "",
                            },
                          }),
                          _vm.singleEntity.title
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.singleEntity.title)),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", [
                        _c("p", { staticClass: "mr-1" }, [
                          _vm._v("The document "),
                          _c("span", { staticClass: "font-bold" }, [
                            _vm._v(_vm._s(_vm.fileName)),
                          ]),
                          _vm._v(" is attached to"),
                        ]),
                        _c(
                          "ul",
                          _vm._l(_vm.attachedToEntities, function (entity) {
                            return _c(
                              "li",
                              { key: entity.id },
                              [
                                entity.title
                                  ? _c("span", { staticClass: "mr-1" }, [
                                      _vm._v(" " + _vm._s(entity.title) + ": "),
                                    ])
                                  : _vm._e(),
                                _vm._l(entity.details, function (attachedTo) {
                                  return _c(
                                    "span",
                                    { key: attachedTo.value },
                                    [
                                      !attachedTo.routeParams
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(attachedTo.value) +
                                                " "
                                            ),
                                          ])
                                        : _c("UILink", {
                                            attrs: {
                                              content: attachedTo.value,
                                              routeParams:
                                                attachedTo.routeParams,
                                              textBase: "",
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]),
                ]),
            _c("ModalSectionsDivider"),
            _c(
              "div",
              { staticClass: "flex pt-5" },
              [
                _c("UiButton", {
                  staticClass: "mr-4",
                  attrs: { buttonText: "Cancel", variant: "outline" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancelled")
                    },
                  },
                }),
                _c("UiButton", {
                  attrs: { buttonText: "Remove" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("confirmed")
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }